import { PickerDropPane, PickerOverlay } from "filestack-react"
import React, { useState } from "react"
import { createPortal } from "react-dom"

import { withFilestackStoreTo } from "../../utils/filestackStoreTo"
import { reportFilestackUploadFailure } from "../../utils/reportFilestackUploadFailure"

const DEFAULT_TRANSFORMATIONS = {
  crop: {
    aspectRatio: 1,
    force: true
  }
}

export const FilePickerDropArea = ({ onUploadDone }) => {
  const pickerOptions = {
    exposeOriginalFile: true,
    maxFiles: 1,
    allowManualRetry: true,
    dropPane: {
      customText: "Drag ‘n’ drop or choose a file"
    },
    onFileUploadFailed: (file) => reportFilestackUploadFailure(file, { component: "FilePickerDropArea" })
  }

  return (
    <PickerDropPane
      apikey={process.env.FILESTACK_API_KEY}
      onUploadDone={onUploadDone}
      pickerOptions={withFilestackStoreTo(pickerOptions)}
    />
  )
}

export const FilePicker = ({
  as = "div",
  onOpen = () => {},
  onUploadDone,
  onFileUploadFailed,
  className,
  maxFiles = 1,
  maxSize,
  imageMin,
  imageMax,
  accept,
  disabled,
  children,
  transformations,
  fromSources,
  allowManualRetry = true
}) => {
  const [showFileUpload, setShowFileUpload] = useState(false)
  const skipTransformations = transformations === null || transformations === false
  const resolvedTransformations = skipTransformations ? undefined : transformations || DEFAULT_TRANSFORMATIONS

  const handleFileUploadFailed = (file) => {
    reportFilestackUploadFailure(file, { component: "FilePicker" })
    if (typeof onFileUploadFailed === "function") {
      onFileUploadFailed(file)
    }
  }

  const pickerOptions = {
    onClose: () => setShowFileUpload(false),
    ...(skipTransformations ? {} : { imageMin: imageMin || [400, 400], transformations: resolvedTransformations }),
    ...(imageMax ? { imageMax } : {}),
    exposeOriginalFile: true,
    maxFiles,
    allowManualRetry,
    ...(maxSize ? { maxSize } : {}),
    ...(accept ? { accept } : {}),
    fromSources,
    onOpen,
    onFileUploadFailed: handleFileUploadFailed
  }

  const Tag = as

  return (
    <>
      <Tag role="button" className={className} onClick={disabled ? () => {} : () => setShowFileUpload(true)}>
        {children}
      </Tag>
      {showFileUpload &&
        createPortal(
          <PickerOverlay
            apikey={process.env.FILESTACK_API_KEY}
            onUploadDone={onUploadDone}
            pickerOptions={withFilestackStoreTo(pickerOptions)}
          />,
          document.body
        )}
    </>
  )
}
